import { Card } from "shared/components/Card";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "shared/components/Popover";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  File02Icon,
  PrinterIcon,
  ViewIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { Applicant } from "types/application";
import { useDownloadReportPdf } from "../../../hooks";

// Use Popover instead of ContextMenuPopover to support hover trigger for the "Print application" menu item.
export const PrintApplicationMenuItem = ({
  applicant,
  disabled
}: {
  applicant: Applicant;
  disabled: boolean;
}) => {
  const { startPolling, isPolling } = useDownloadReportPdf({
    applicationId: String(applicant.application_id || 0),
    applicantId: String(applicant.id || 0)
  });

  return (
    <Popover placement="right-start" trigger="hover">
      <PopoverTrigger>
        <div className="flex gap-3 py-0.5 items-center">
          <HugeiconsIcon
            icon={PrinterIcon}
            size={20}
            className="text-content-200"
          />
          <span>{isPolling ? "Processing..." : "Print application"}</span>
        </div>
      </PopoverTrigger>
      <PopoverContent className="Popover z-[12]">
        <Card className="w-[382px] -mt-2 mr-4">
          <div className="h-px bg-alpha-40 w-full" />
          <div
            className="flex gap-3 items-center px-4 py-2.5 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              if (disabled) return;
              startPolling({
                include_redacted_report: false,
                include_government_id_report: false
              });
            }}
          >
            <HugeiconsIcon
              icon={File02Icon}
              size={20}
              className="text-content-200 shrink-0"
            />
            <div className="flex flex-col items-start">
              <p className="text-base font-medium text-content-1000">
                Print full version
              </p>
              <p className="text-xs font-medium text-content-400">
                Default version that includes all data
              </p>
            </div>
          </div>
          <div className="h-px bg-alpha-40 w-full" />
          <div
            className="flex gap-3 items-center px-4 py-2.5 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              if (disabled) return;
              startPolling({
                include_redacted_report: true,
                include_government_id_report: false
              });
            }}
          >
            <HugeiconsIcon
              icon={ViewIcon}
              size={20}
              className="text-content-200 shrink-0"
            />
            <div className="flex flex-col items-start">
              <p className="text-base font-medium text-content-1000">
                Redacted version
              </p>
              <p className="text-xs font-medium text-content-400">
                Excludes personal identifying details for privacy
              </p>
            </div>
          </div>
          <div className="h-px bg-alpha-40 w-full" />
        </Card>
      </PopoverContent>
    </Popover>
  );
};
